import { NavLink } from "react-router-dom";
import { Home, Calendar, Settings, FileText } from "lucide-react";
import { useAppAuth } from "@/context/AppAuthContext";
import { temPermApp } from "@/components/app/AppPermGuard";

export default function AppBottomNav() {
  const { session } = useAppAuth();
  const items = [
    { to: "/app", label: "Hoje", id: "hoje", icon: Home, end: true },
    temPermApp(session, "perm_consultar") && { to: "/app/historico", label: "Histórico", id: "histórico", icon: Calendar },
    temPermApp(session, "perm_atestados", "perm_justificativas") && { to: "/app/justificativas", label: "Justificativas", id: "justificativas", icon: FileText },
    { to: "/app/settings", label: "Conf.", id: "config", icon: Settings },
  ].filter(Boolean);
  // Faz parte do layout (não flutua): sempre visível, sem precisar rolar a página
  return (
    <nav className="shrink-0 z-30 bg-slate-900 border-t border-slate-800 pb-[env(safe-area-inset-bottom)]" data-testid="app-bottom-nav">
      <div className="max-w-md mx-auto grid h-14" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map((it) => (
          <NavLink key={it.to} to={it.to} end={it.end}
            data-testid={`nav-app-${it.id}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 text-[10px] font-semibold transition-colors min-w-0
              ${isActive ? "text-emerald-400" : "text-slate-500 hover:text-slate-200"}`
            }>
            <it.icon size={18} />
            <span className="truncate max-w-full px-0.5">{it.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
